import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common/Header';
import Profile from '../../Models/Profile'
import FollowFavourites from '../../Models/FollowFavourites';
import { Footer } from '../Common';
import { Spinner } from 'reactstrap';
import Common from "../../Models/Common";

class ProfileDetails extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert(this.props.t('1'))
            this.props.history.push('/login/seller');
        };
        this.state = {
            minHeight: "475px",
            modalIsOpen: false,
            profession: '',
            photo_id: null,
            utility: null,
            services: [],
            portfolio: [],
            area: '',
            address: '',
            x: '',
            profieId: '',
            followDetails: [],
            profile_picture: null,
            status: '',
            profile: [],
            personal: [],
            intro: ''
        };
        console.log(this.props.match.params.id)
        this.getFollowShow()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getServiceList(this.props.match.params.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ services: res.data.payload, status: res.data.status })
            }
        })
        Profile.getPortfolio(this.props.match.params.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ portfolio: res.data.payload, status: res.data.status })
            }
        })
        Profile.getProfile(this.props.match.params.id).then(res => {
            if (res.data.profile != null) {
                this.setState({ profile: res.data.profile })
                this.setState({ personal: res.data.personal })
                this.setState({ intro: res.data.personal.personal_details })
                this.setState({ profieId: res.data.profile.user_id })
            }
        })
    }

    getFollowShow() {
        let x = JSON.parse(localStorage.getItem('info'))
        if (x !== null) {
            FollowFavourites.getFollow(this.props.match.params.id, x.id).then(res => {
                this.setState({
                    followDetails: res.data.flag
                })
            })
        } else {
            FollowFavourites.getFollow(this.props.match.params.id, 0).then(res => {
                this.setState({
                    followDetails: res.data.flag
                })
            })
        }
    }

    handleFollow() {
        let x = JSON.parse(localStorage.getItem('info'))
        FollowFavourites.sendFollow(this.state.profieId, x.id).then(res => {
            this.setState({
                followDetails: res.data.flag
            })
            alert(this.props.t('7'))
        })
    }

    handleFollowRemove() {
        let x = JSON.parse(localStorage.getItem('info'))
        FollowFavourites.sendRemoveFollow(this.state.profieId, x.id).then(res => {
            this.setState({
                followDetails: res.data.flag
            })
            alert(this.props.t('0'))
        })
    }

    contractProfile(id) {
        if (localStorage.getItem('info')) {
            let x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: "/affiliator-direct-message"+"/"+encodeURIComponent(x.id+"&"+id),
                        state: {
                            buyer_id: x.id,
                            seller_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <button className="btn " style={{ textAlign: "center", fontSize: "13px", width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}> {this.props.t('2')}</button>
                    </Link >
                )
            } else if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: '/buyer-direct-message'+"/"+encodeURIComponent(x.id+"&"+id),
                        state: {
                            buyer_id: x.id,
                            seller_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <button className="btn " style={{ textAlign: "center", fontSize: "13px", width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}> {this.props.t('2')}</button>
                    </Link >
                )
            } else if (x.user_type_id === 2 && x.id !== id) {
                return (
                    <Link to={{
                        pathname: '/seller-direct-message',
                        state: {
                            buyer_id: x.id,
                            seller_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <button className="" style={{ textAlign: "center", fontSize: "13px", width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}> {this.props.t('2')}</button>
                    </Link >
                )
            }
        }
    }

    follow() {
        if (JSON.parse(localStorage.getItem('info')) === null || JSON.parse(localStorage.getItem('info')) === '') {
            return (
                <button className="btn btn-secondray ml-4 mb-2" style={{ fontSize: '12px' }}>{this.props.t('10')}</button>
            )
        } else {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.id === this.state.profieId) {
                return (
                    <div></div>
                )
            } else {
                if (this.state.followDetails === 0) {
                    return (
                        <button type="submit" onClick={this.handleFollow.bind(this)} className="btn btn-secondray ml-4 mb-2" style={{ fontSize: '12px', border: '1px solid #ccc' }}>{this.props.t('10')}</button>
                    )
                } else {
                    // {this.props.t('10')}
                    return (
                        <button type="submit" onClick={this.handleFollowRemove.bind(this)} className="btn btn-secondray ml-4 mb-2" style={{ fontSize: '12px', border: '1px solid #ccc' }}>{this.props.t('15')}</button>
                    )
                }
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            if (this.state.status === 200) {
                return (
                    <div  className="wrapper">
                        <div className="container-fluid">
                            <div className="col-md-12" >
                                <div className="">
                                    <Header />
                                </div>
                            </div>
                            <div className="mt-5 ml-5">&nbsp;</div>
                            <div className="mt-2 ml-5">&nbsp;</div>
                            <div className="col-md-12 main" style={{ minHeight: "800px" }}>
                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <img style={{ borderRadius: "50%" }} alt="" src={Common.baseUrl + this.state.profile.img} height="140" width='140' style={{ objectFit: 'cover' }} className="rounded-circle" />
                                    </div>
                                    <div style={{ padding: "2%", width: "100%" }}>
                                        <div className="row">
                                            <div className="col-md-12 text-center">
                                                <h4><b><i>{this.state.personal.first_name}</i></b></h4>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="text-center">
                                                    {this.follow()}
                                                </div>
                                                <div className="text-center">
                                                    {this.contractProfile(this.state.profieId)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", fontSize:'13px' , padding: "4%", textAlign: "left", minHeight: "200px" }}>
                                        <div>
                                            {(() => {
                                                if (this.state.intro !== null) {
                                                    return (
                                                        this.state.intro.split('\n').map((item, key) =>
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    )
                                                } else {
                                                    return (
                                                        <div className=""></div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                                <div>&nbsp;</div>
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", fontSize:'13px' ,padding: "4%", textAlign: "center", minHeight: "200px" }}>
                                        <div className=" row" style={{padding:'6px'}}>
                                            <div className="col-md-4" style={{ textAlign: "left" }}>
                                                {this.props.t('20')} :
                                            </div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {this.state.profile.profession}
                                            </div>
                                        </div>
                                        <div className=" row"style={{padding:'6px'}}>
                                            <div className="col-md-4" style={{ textAlign: "left" }}>
                                                {this.props.t('21')} :
                                            </div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {this.state.profile.description}
                                            </div>
                                        </div>
                                        {/*<div className=" row"style={{padding:'6px'}}>*/}
                                        {/*    <div className="col-md-4" style={{ textAlign: "left" }}>*/}
                                        {/*        {this.props.t('13')} :*/}
                                        {/*    </div>*/}
                                        {/*    <div className="col-md-7" style={{ textAlign: "left" }}>*/}
                                        {/*        {this.state.profile.area}*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className=" row"style={{padding:'6px'}}>
                                            <div className="col-md-4" style={{ textAlign: "left" }}>
                                                {this.props.t('22')} :
                                            </div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {this.state.profile.address}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                                <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                    <div className="col-md-1"></div>
                                    <div className="col-md-5" style={{ textAlign: "left" }}>
                                        <h5>{this.props.t('5')}</h5>
                                    </div>
                                    <div className="col-md-5" style={{ textAlign: "right" }}>
                                        <Link to={{
                                            pathname: `/seller-service-list/${this.props.match.params.id}`,
                                            state: { id: this.props.match.params.id }
                                        }} style={{ textDecoration: 'none' }}>
                                            <span className="sky-a">{this.props.t('16')}</span>
                                        </Link>
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                                {(() => {
                                    if (this.state.services.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                                <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                    {this.state.services.map(group =>
                                                        <div className="col-md-3" style={{ padding: "2%" }}>
                                                            <div style={{ height: '200px' }}><img style={{ height: "100%", width: "100%", objectFit: 'cover' }} src={Common.baseUrl + group.img}></img></div>
                                                            <div>{group.title.substring(1, 15)}..</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                })()}
                                <div className="row">
                                    &nbsp;
                                </div>
                                <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                    <div className="col-md-1"></div>
                                    <div className="col-md-5" style={{ textAlign: "left" }}>
                                        <h5>{this.props.t('8')}</h5>
                                    </div>
                                    <div className="col-md-5" style={{ textAlign: "right" }}>
                                        <Link to={{
                                            pathname: `/my-portfolio-view/${this.props.match.params.id}`,
                                            state: { id: this.props.match.params.id }

                                        }} style={{ textDecoration: 'none' }}>
                                            <span className="sky-a">{this.props.t('16')}</span>
                                        </Link>
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                                {(() => {
                                    if (this.state.portfolio.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                                <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                    {this.state.portfolio.map(group =>
                                                        <div className="col-md-3" style={{ padding: "2%" }}>
                                                            <div><img style={{ height: "200px", width: "200px" }} src={Common.baseUrl + group.img}></img></div>
                                                            <div>{group.title.substring(1, 15)}...</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                })()}
                                <div className="row">

                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mt-5" >
                            <div className=" mt-5">
                                <Footer />
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="container-fluid">
                        <div className="container">
                            <div className="" style={{ height: '380px' }}></div>
                            <div className="text-center mt-3">
                                <Spinner color="primary" size="150" />
                            </div>
                        </div>
                    </div>
                )

            }
        }
        //for Desktop
        else if (isDesktop) {
            if (this.state.status === 200) {
                return (
                    <div className="wrapper">
                        <div className="container-fluid">
                            <div className="container">
                                <div className="col-md-12" >
                                    <div className="">
                                        <Header />
                                    </div>
                                </div>
                                <div className="mt-5 ml-5">&nbsp;</div>
                                <div className="mt-2 ml-5">&nbsp;</div>
                                <div className="container main" style={{ minHeight: "800px" }}>
                                    <div className="row">
                                        <div className="ml-5 mt-2">
                                            <img style={{ borderRadius: "50%" }} alt="" src={Common.baseUrl + this.state.profile.img} height="140" width='140' style={{ objectFit: 'cover' }} className="rounded-circle" />
                                        </div>
                                        <div style={{ paddingLeft: "19%", paddingTop: "2%", width: "70%" }}>
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <h4><b><i>{this.state.personal.first_name}</i></b></h4>
                                                </div>
                                                <div className="col-md-5 text-right">
                                                    {this.follow()}
                                                    {this.contractProfile(this.state.profieId)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "left", minHeight: "200px" }}>
                                            <div>
                                                {(() => {
                                                    if (this.state.intro !== null) {
                                                        return (
                                                            this.state.intro.split('\n').map((item, key) =>
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        )
                                                    } else {
                                                        return (
                                                            <div className=""></div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "center", minHeight: "200px" }}>
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('20')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.profession}
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('21')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.description}
                                                </div>
                                            </div>
                                            {/*<div className="col-md-12 row">*/}
                                            {/*    <div className="col-md-4" style={{ textAlign: "right" }}>*/}
                                            {/*        <b><i>{this.props.t('13')}:</i></b>*/}
                                            {/*    </div>*/}
                                            {/*    <div className="col-md-1"></div>*/}
                                            {/*    <div className="col-md-7" style={{ textAlign: "left" }}>*/}
                                            {/*        {this.state.profile.area}*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('22')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.address}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                    <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                        <div className="col-md-1"></div>
                                        <div className="col-md-5" style={{ textAlign: "left" }}>
                                            <h3>{this.props.t('5')}</h3>
                                        </div>
                                        <div className="col-md-5" style={{ textAlign: "right" }}>
                                            <Link to={{
                                                pathname: `/seller-service-list/${this.props.match.params.id}`,
                                                state: { id: this.props.match.params.id }
                                            }} style={{ textDecoration: 'none' }}>
                                                <span className="sky-a"><b>{this.props.t('16')}</b></span>
                                            </Link>
                                        </div>
                                        <div className="col-md-1"></div>
                                    </div>
                                    {(() => {
                                        if (this.state.services.length === 0) {
                                            return (
                                                <div></div>
                                            )
                                        } else {
                                            return (
                                                <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                                    <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                        {this.state.services.map(group =>
                                                            <div className="col-md-3" style={{ padding: "2%" }}>
                                                                <div style={{ height: '200px' }}><img style={{ height: "100%", width: "100%", objectFit: 'cover' }} src={Common.baseUrl + group.img}></img></div>
                                                                <div className="text-truncate">{group.title}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })()}
                                    <div className="row">
                                        &nbsp;
                            </div>
                                    <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                        <div className="col-md-1"></div>
                                        <div className="col-md-5" style={{ textAlign: "left" }}>
                                            <h3>{this.props.t('8')}</h3>
                                        </div>
                                        <div className="col-md-5" style={{ textAlign: "right" }}>
                                            <Link to={{
                                                pathname: `/my-portfolio-view/${this.props.match.params.id}`,
                                                state: { id: this.props.match.params.id }

                                            }} style={{ textDecoration: 'none' }}>
                                                <span className="sky-a"><b>{this.props.t('16')}</b></span>
                                            </Link>
                                        </div>
                                        <div className="col-md-1"></div>
                                    </div>
                                    {(() => {
                                        if (this.state.portfolio.length === 0) {
                                            return (
                                                <div></div>
                                            )
                                        } else {
                                            return (
                                                <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                                    <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                        {this.state.portfolio.map(group =>
                                                            <div className="col-md-3" style={{ padding: "2%" }}>
                                                                <div><img style={{ height: "200px", width: "200px" }} src={Common.baseUrl + group.img}></img></div>
                                                                <div>{group.title.substring(1, 15)}...</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })()}
                                    <div className="row">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mt-5" >
                            <div className=" mt-5">
                                <Footer />
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="container-fluid">
                        <div className="container">
                            <div className="" style={{ height: '380px' }}></div>
                            <div className="text-center mt-3">
                                <Spinner color="primary" size="150" />
                            </div>
                        </div>
                    </div>
                )

            }
        }
    }
}

export { ProfileDetails };


 ProfileDetails = withTranslation('src_Components_Profile_ProfileDetails')(ProfileDetails);
